 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		59: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"0":"async/SinglePatternView","1":"async/SingleSewpatView","2":"async/CategoriesOverview","3":"async/Home","4":"async/SewpatGallery","5":"async/NewsletterForm","6":"async/ColorSwatchesCartForm","7":"async/FavoritesGallery","8":"async/SearchResult","9":"async/PatterngalleryNewest","10":"async/NewsletterSubscribed","11":"async/DesignerGallery","12":"async/CategoryPatterns","13":"async/PatternGalleries","14":"header/PatternCategories","15":"header/SingleSewpatView","16":"header/SewpatGallery","17":"header/Header","18":"header/FavoritesGallery","19":"header/DesignerGallery","20":"header/Drawer","21":"async/Hashtag","22":"header/Navigation","23":"header/MainMenuDrawer","24":"header/MainMenuDrawerBKP","25":"async/Header","26":"header/NotFound","27":"async/SewpatGalleries","28":"async/enShipping","29":"async/deShipping","30":"async/enAbout","31":"async/deAbout","32":"async/SewpatCard","33":"header/DrawerMenuItem","34":"async/SubCategoryGallery","35":"async/TopCategoriesGalleries","36":"async/Fabrics","37":"async/defaq-coloring-options","38":"async/enfaq-coloring-options","39":"async/enTos","40":"async/enPrivacy","41":"async/enImprint","42":"async/deTos","43":"async/dePrivacy","44":"async/deImprint","45":"header/ExpandableSiteSearch","46":"header/DrawerMenu","47":"header/HeaderBase","48":"header/NavigationRight","49":"header/HeaderToolbar","50":"async/PatternRepeat","51":"async/LogoQ","52":"async/LinearProgress","53":"header/SearchIcon","54":"header/NavLink","55":"async/Logo","56":"async/Heading","57":"async/ExternalLink"}[chunkId]||chunkId) + "." + {"0":"d0d33e9e3cd360f92e2d","1":"6a5b6b59f6878d3186cb","2":"3341abfde9a12eddc9c2","3":"2792fad0d79e9a3b17b6","4":"c0868c29200bcba760d3","5":"5438a2ddf61c7f5b9330","6":"dfd11f41c0c6b54f5153","7":"a16abaf77b6d448a2315","8":"a999341500b346d5b972","9":"e078226bb7c489ad1da0","10":"c8232ab9ae23b34bbecf","11":"530f22e5f3221ba6c287","12":"1ff9ffaa6d120eadb7de","13":"6d107f3e0a966f5413db","14":"fc11c6129e2f216147f8","15":"e9f689d9086ae1f25c27","16":"891ec4c0dc5d25bea235","17":"42f95e0562075381cd8a","18":"194c4da64429b8089db4","19":"ff4367c62fdc857591f5","20":"566da64bc210ee214eba","21":"e1f61e78a17d40bbdf0c","22":"25db2f2eb6ec0940e99a","23":"99ff88544c3b85e7e142","24":"bc81984449ec29550794","25":"b443989156d5bfe53133","26":"58090358a5a8979ee96b","27":"089fcd8276026bf36fea","28":"eeca1fc7f5925544792f","29":"21f14cdaa8ac73ed4d25","30":"c81cc045e6acad8286d8","31":"1c1471bb365b49ae737e","32":"8d53b52b2c22a812fe2a","33":"d11f52c65505c2256405","34":"071e6306583c40d71c63","35":"c3f9ec5012edf5d7759d","36":"96a18094f243ed670bbb","37":"666252946fddc6d2d312","38":"6f25603ac260f0c2f431","39":"289d23415cce99636239","40":"ac865fcf9238305c808a","41":"a82c205591520926bc68","42":"7e30424fd9239919d22b","43":"40ea2a768aa046c09c7b","44":"7409a0eb0f7dc68b213a","45":"4b9031ae19305c007bcd","46":"0651dff708a163a50e5d","47":"3142397eec6f0ddcde7a","48":"cd553483203aef30960f","49":"924a68920713fa48b258","50":"4c3907227a6ac794cbb5","51":"571f9d0d8601ac454497","52":"81adfdacd2dfbfa46d28","53":"6e895abacb7ac8196655","54":"9bd4fe0b42f7be4bc1fb","55":"32103f1c1fa77036c9f7","56":"2e1d001535f14d5433b6","57":"8e79a345e00a35fe4674"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 11ef68371612c2348ad1